import { render, staticRenderFns } from "./NewDDocumentPreview.vue?vue&type=template&id=2ee65fe3&"
import script from "./NewDDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./NewDDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDDocumentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports